<template>
  <sub-page title="见习人员确认">
    <div class="confirm-page">
      <!-- 用户信息 -->
      <div class="user-card">
        <div class="avatar">
          <svg viewBox="0 0 24 24" class="avatar-icon"><circle cx="12" cy="8" r="4" fill="#c8c9cc"/><path d="M4 20 C4 15 8 13 12 13 C16 13 20 15 20 20 Z" fill="#c8c9cc"/></svg>
        </div>
        <div class="user-info">
          <div class="user-name">戴义杰</div>
          <div class="user-id">3411**********5619</div>
        </div>
      </div>

      <!-- 见习协议 -->
      <div class="section-title">见习协议信息</div>
      <div class="agree-card">
        <div class="status-line">
          <span class="status-tag">待确认</span>
          <span class="status-tip">请核对以下协议信息，确认无误后点击底部按钮完成确认</span>
        </div>
        <div class="info-item"><span class="label">协议编号</span><span class="value">JX2026090088</span></div>
        <div class="info-item"><span class="label">见习单位</span><span class="value">江苏超芯星半导体有限公司</span></div>
        <div class="info-item"><span class="label">见习岗位</span><span class="value">半导体工艺工程师见习岗</span></div>
        <div class="info-item"><span class="label">岗位工种</span><span class="value">专业技术人员</span></div>
        <div class="info-item"><span class="label">见习期限</span><span class="value">2026-09-15 至 2027-03-14（6个月）</span></div>
        <div class="info-item"><span class="label">见习补贴</span><span class="value">2880 元/月</span></div>
        <div class="info-item"><span class="label">带教老师</span><span class="value">李工</span></div>
        <div class="info-item"><span class="label">经办机构</span><span class="value">南京市江北新区社会事业局</span></div>
      </div>

      <div class="notice-box">
        <div class="notice-title">确认须知</div>
        <div class="notice-line">1. 见习期间由见习单位为您办理人身意外伤害保险；</div>
        <div class="notice-line">2. 见习补贴按月发放至本人社会保障卡金融账户；</div>
        <div class="notice-line">3. 确认后协议生效，请按单位要求按时参加见习。</div>
      </div>

      <div class="footer-btn">
        <button class="submit-btn" :disabled="confirmed" @click="handleConfirm">{{ confirmed ? '已确认' : '确认无误，同意协议' }}</button>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'InternshipConfirm',
  components: { SubPage },
  data() {
    return {
      confirmed: false
    }
  },
  methods: {
    handleConfirm() {
      if (this.confirmed) return
      this.confirmed = true
      this.$alert('见习协议确认成功，协议编号 JX2026090088 已生效，请于 2026-09-15 前到见习单位报到')
    }
  }
}
</script>

<style scoped>
.confirm-page {
  background: #F3F8FB;
  min-height: 100%;
  padding-bottom: calc(40 * var(--w));
}
.user-card {
  display: flex;
  align-items: center;
  background: #fff;
  padding: calc(32 * var(--w));
  gap: calc(24 * var(--w));
}
.avatar {
  width: calc(100 * var(--w));
  height: calc(100 * var(--w));
  border-radius: 50%;
  background: #f2f2f2;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}
.avatar-icon {
  width: 100%;
  height: 100%;
}
.user-name {
  font-size: calc(36 * var(--w));
  font-weight: bold;
  color: #323233;
  margin-bottom: calc(8 * var(--w));
}
.user-id {
  font-size: calc(28 * var(--w));
  color: #646566;
}
.section-title {
  font-size: calc(30 * var(--w));
  font-weight: bold;
  color: #323233;
  padding: calc(28 * var(--w)) calc(32 * var(--w)) calc(16 * var(--w));
}
.agree-card {
  background: #fff;
  border-radius: calc(12 * var(--w));
  margin: 0 calc(24 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.status-line {
  display: flex;
  align-items: center;
  gap: calc(16 * var(--w));
  padding-bottom: calc(20 * var(--w));
  margin-bottom: calc(12 * var(--w));
  border-bottom: 1px dashed #ebedf0;
}
.status-tag {
  font-size: calc(26 * var(--w));
  color: #ff976a;
  background: #FFF3EB;
  padding: calc(6 * var(--w)) calc(20 * var(--w));
  border-radius: calc(8 * var(--w));
  flex-shrink: 0;
}
.status-tip {
  font-size: calc(24 * var(--w));
  color: #969799;
}
.info-item {
  display: flex;
  align-items: flex-start;
  font-size: calc(28 * var(--w));
  line-height: 1.9;
}
.label {
  color: #969799;
  white-space: nowrap;
  width: calc(170 * var(--w));
  flex-shrink: 0;
}
.value {
  color: #323233;
  flex: 1;
}
.notice-box {
  margin: calc(24 * var(--w));
  background: #FFFBEF;
  border-radius: calc(12 * var(--w));
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.notice-title {
  font-size: calc(28 * var(--w));
  font-weight: bold;
  color: #B07A1E;
  margin-bottom: calc(8 * var(--w));
}
.notice-line {
  font-size: calc(26 * var(--w));
  color: #8A6D3B;
  line-height: 1.9;
}
.footer-btn {
  padding: calc(24 * var(--w)) calc(32 * var(--w));
}
.submit-btn {
  width: 100%;
  height: calc(88 * var(--w));
  background: #2E8CF6;
  color: #fff;
  font-size: calc(36 * var(--w));
  border: none;
  border-radius: calc(8 * var(--w));
  cursor: pointer;
}
.submit-btn:disabled {
  background: #c8c9cc;
}
</style>



// WEBPACK FOOTER //
// src/pages/InternshipConfirm.vue